import { Navigate, useNavigate, useParams } from "react-router-dom";
import { ItemFormModal, type ItemKind } from "../components/items/ItemFormModal";
import { useTabStore } from "../lib/tabStore";

/**
 * YENİ KART (Stok / Yarı Mamul / Mamul) — uygulama içi SEKME olarak.
 *
 * Eskiden çekmeceydi. Sekme olmasının kazancı: kullanıcı kartı doldururken listeye,
 * reçeteye ya da başka bir sayfaya bakıp geri dönebiliyor ve form yarım kalmıyor —
 * çekmecede bu mümkün değildi (sayfadan çıkınca çekmece de giderdi).
 *
 * Kaydedince: sekme KENDİNİ KAPATIR ve liste sekmesine dönülür. Liste zaten mutasyonun
 * `invalidateQueries` çağrısıyla tazelenmiştir; ayrıca sekmeye dönüşte bayat sorgular
 * yeniden çekilir (TabViews).
 */
const KINDS: Record<string, ItemKind> = { stock: "stock", semi: "semi", finished: "finished" };

export function ItemNewPage() {
  const { kind: raw } = useParams();
  const navigate = useNavigate();
  const closeTab = useTabStore((s) => s.close);
  const kind = KINDS[raw ?? ""];
  const listPath = `/items/${raw ?? "stock"}`;

  /** Sekmeyi kapat + listeye dön. Kapatma başarısızsa (sekme yoksa) yine de listeye gider. */
  const back = () => {
    closeTab(`/items/${raw ?? "stock"}/yeni`);
    navigate(listPath);
  };

  /**
   * BİLİNMEYEN TÜR (/items/zzz/yeni) → stok kartına yönlendir.
   *
   * Sessizce "stock" varsayılamaz: sekme kataloğunda yalnız üç yol var, dolayısıyla
   * bilinmeyen tür için SEKME AÇILMAZ; adres o yolda takılır ve ekranda önceki sekme
   * kalır — kullanıcı adres çubuğuyla eşleşmeyen bir sayfaya bakar. Yönlendirme bunu
   * kesin olarak kapatır (bileşen sekmesiz konumlarda gizli Outlet'te mount olur).
   */
  if (!kind) return <Navigate to="/items/stock/yeni" replace />;

  return (
    <ItemFormModal
      open
      variant="page"
      kind={kind}
      onClose={back}
      onCreated={back}
    />
  );
}
